
import React, { Component } from 'react';
import { connect } from 'react-redux'

import SliderComponent from './SliderComponent';

var translator = require('../../utils/translator/translator');
var soundSettingsUtils = require('../../utils/domain/settings/soundSettingsUtils');
var sounds = require('../../utils/sounds/sounds');

class SoundSettingsView extends Component 
{
    render()
    {
        return <div>
                    <div>
                        <SliderComponent
                            min={0} max={1} step={0.1} 
                            getValue={()=>
                            {
                                return soundSettingsUtils.getNewOrderSoundVolume();
                            }}
                            setValue={(value)=>
                            {
                                soundSettingsUtils.setNewOrderSoundVolume(value);
                                sounds.playNewOrderSound();
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("new_order_sound_volume")
                            }}
                            usePlainCaption={false}
                            getHints={()=>
                            {
                                return translator.getLabel("please_choose_the_desired_volume_for_the_sound_alert_triggered_by_the_system_upon_receiving_a_new_order")
                            }}/>
                    </div>
                </div>
    }

}

const mapStateToProps = state => 
{
    return { 
                settingsChangedTimeStamp: state.settingsChangedTimeStamp,
           }
}

export default connect(mapStateToProps)(SoundSettingsView)